import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ProductTagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: ${SPACING.SMALL};
    align-items: center;
`;

export const ImageContainer = styled.div`
    width: 50px;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
